(() => {
  angular
    .module('gm.common.providers')
    .provider('gmyAcl', gmyAclProvider);

  function gmyAclProvider() {
    'ngInject';

    const PERMISSIONS = {
      ANONYMOUS: 'ANONYMOUS',
      SIGNUP_FINISHED: 'SIGNUP_FINISHED',
      SIGNUP_PROCESS: 'SIGNUP_PROCESS'
    };

    return {
      PERMISSIONS,
      $get(GmyProfile) {
        return {
          PERMISSIONS,
          getPath,
          isSignUpFinished,
        };

        function getPath(profile) {
          if (!profile) {
            return '/sign-in';
          }

          switch (profile.accountType) {
            case GmyProfile.PROFILE_TYPES.BUSINESS: {
              const businessProfile = profile.businessProfile;

              if (!businessProfile.businessName) {
                return '/network/onboarding/business/business-info';
              }

              if (!businessProfile.corporate.address.street) {
                return '/network/onboarding/business/business-info-continued';
              }

              if (!profile.firstName || !profile.lastName) {
                return '/network/onboarding/business/personal-info';
              }

              if (!profile.phoneVerified) {
                return '/network/onboarding/business/phone-verification';
              }

              if (!profile.documentSent) {
                return '/network/onboarding/business/upload-id';
              }
              break;
            }
            case GmyProfile.PROFILE_TYPES.PERSONAL:
              if (!profile.firstName || !profile.lastName) {
                return '/network/onboarding/personal/personal-info';
              }

              if (!profile.phoneVerified) {
                return '/network/onboarding/personal/phone-verification';
              }

              if (!profile.profileValidated) {
                return '/network/onboarding/personal/address';
              }
              break;
            default:
              return false;
          }

          return false;
        }

        function isSignUpFinished(profile) {
          return profile && profile.profileValidated
            && ((profile.accountType === GmyProfile.PROFILE_TYPES.BUSINESS)
              ? profile.documentSent : true);
        }
      }
    };
  }
})();
